import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

// Renders its children into the topbar, beside the page title. The slot is part
// of the layout, so a page that unmounts takes its control with it.
const HeaderSlot = ({ children }) => {
  const [host, setHost] = useState(null);
  useEffect(() => {
    setHost(document.getElementById('topbar-slot'));
  }, []);
  return host ? createPortal(children, host) : null;
};

export default HeaderSlot;
